import React from "react";
import {ExchangeBuy} from "./ExchangeBuy";
import {ExchangeSell} from "./ExchangeSell";
import {ExternalPayout} from "./ExternalPayout";
import {StandardPayin} from "./StandardPayin";
import {StandardPayout} from "./StandardPayout";
import type {WorkflowStageContext} from "./stage";
import {resolveWorkflowModule} from "./workflow";
export {resolveWorkflowModule} from "./workflow";

interface WorkflowStagesProps {
    workflowKind: string;
    context: WorkflowStageContext | null;
}

export function WorkflowStages({
    workflowKind,
    context,
}: WorkflowStagesProps): JSX.Element {
    const module = resolveWorkflowModule(workflowKind);
    if (module === "unsupported" || context == null) {
        return (
            <section className="details-section">
                <div className="details-lock-hint" role="status">Сценарий не поддерживается</div>
            </section>
        );
    }

    switch (module) {
        case "standard_payin":
            return <StandardPayin context={context}/>;
        case "standard_payout":
            return <StandardPayout context={context}/>;
        case "external_payout":
            return <ExternalPayout context={context}/>;
        case "exchange_buy":
            return <ExchangeBuy context={context}/>;
        case "exchange_sell":
            return <ExchangeSell context={context}/>;
    }
}
